import Vue from 'vue'
import Vuex from 'vuex'
//import * as actions from './actions'
//import * as getters from './getters'

Vue.use(Vuex)

// 应用初始状态
const state = {
	menukey: STATIC_CONFIG.menukey,
	customerid: '',
  entityName: '',
	setentityName: function(name) {
		this.entityName = name
	},
	//动画
	direction: 'forward',
	UPDATE_LOADING(status) {
		this.isLoading = status
	},
	UPDATE_DIRECTION(direction) {
		this.direction = direction
	}


}

//// 定义所需的 mutations
//const mutations = {
//  SetdialogExpenseDetailVisible(state, dialogExpenseDetailVisible) {
//      state.dialogExpenseDetailVisible = dialogExpenseDetailVisible
//  },
//  setDemanderUser(state,demanderUser){
//  	state.demanderUser = demanderUser;
//  }
// 
//}

// 创建 store 实例
export default new Vuex.Store({
	//  actions,
	//  getters,
	state
	//mutations
})



// WEBPACK FOOTER //
// ./src/vuex/store.js